import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { FOLLOW_REPLY_CHANNEL } from 'apps/followReply/constants'
import { FollowReplyState } from 'apps/followReply/interfaces'
import { getChannelState, NAMESPACE } from 'apps/followReply/store/constants'
import { followReplyApi } from 'shared/api/requests/followReply'
import { createAsyncAction } from 'shared/lib/redux'

export const updateDelay = createAsyncAction(`${NAMESPACE}/updateDelay`, async (delay: number) => {
  const response = await followReplyApi.updateDelay({
    body: { delay },
  })

  return response.data
})

export const updateDelayReducer = (builder: ActionReducerMapBuilder<FollowReplyState>) => {
  builder.addCase(updateDelay.pending, (state) => {
    state[FOLLOW_REPLY_CHANNEL].fetching = true
  })
  builder.addCase(updateDelay.fulfilled, (state, action) => {
    const data = action.payload
    state[FOLLOW_REPLY_CHANNEL] = getChannelState(data)
  })
  builder.addCase(updateDelay.rejected, (state) => {
    state[FOLLOW_REPLY_CHANNEL].fetching = false
  })
}
